export default __webpack_public_path__ + "static/media/app_store.907aad62.svg";